import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FieldArray, formValueSelector } from 'redux-form/immutable'
import { Table } from 'semantic-ui-react'
import RenderFormPrecos from './RenderFormPrecos'

const selector = formValueSelector('PldMedioForm')

let RenderMeses = ({ mes, ano, mes_nome }) =>
  <Table.Row>
    <Table.Cell textAlign='right'>
      {mes_nome}/{ano}
    </Table.Cell>

    <FieldArray
      name={`${mes}.precos`}
      component={RenderFormPrecos}
    />
  </Table.Row>

RenderMeses = connect(
  (state, props) => {
    return ({
      ano: selector(state, `${props.mes}.ano`),
      mes_nome: selector(state, `${props.mes}.mes_nome`)
    })
  }
)(RenderMeses)

RenderMeses.propTypes = {
  submercado: PropTypes.string,
  loading: PropTypes.bool,
  mes: PropTypes.string,
  ano: PropTypes.string,
  mes_nome: PropTypes.string,
}

export default RenderMeses
